@if(questionnaireTypeId==='1'){
<div class="agreenment-card">
    <mat-toolbar class="custom-toolbar">
        <div class="toolbar-section left" style="width: 33%;">
            <!-- 左邊內容，例如返回按鈕 -->

        </div>
        <div class="toolbar-section center" style="width: 33%;text-align: center;">
            <span>{{questionnaireName}}</span>
        </div>
        <div class="toolbar-section right" style="width: 33%;text-align: right">
            <!-- 右邊內容，例如選單或儲存按鈕 -->
            <button class="header-right-btn-language btn-text btn-size-l" (click)="leavePage()">
                離開
            </button>
        </div>
    </mat-toolbar>
    <mat-progress-bar mode="determinate" [value]="percentValue"></mat-progress-bar>
    <div style="background-color: #f2f7f6;">
        <app-form-detail [questions]="groupedQuestions[currentGroupIndex] || []" [answerGroups]="currentAnswerGroups"
            [groupIndex]="currentGroupIndex" [questionnaireTypeId]="questionnaireTypeId"
            [groupCount]="groupedQuestions.length" [questionErrorMessages]="questionErrorMessages"
            [groupedQuestions]="groupedQuestions" [totalQuestions]="totalQuestions"
            [questionPlaceholders]="questionPlaceholders" (navigationChange)="onNavigationChange($event)">
        </app-form-detail>
    </div>
</div>
}
@if(questionnaireTypeId==='2'){
<div class="agreenment-card">
    <mat-toolbar class="custom-toolbar">
        <div class="toolbar-section left" style="width: 33%;">
            <!-- 左邊內容，例如返回按鈕 -->

        </div>
        <div class="toolbar-section center" style="width: 33%;text-align: center;">
            <span>{{questionnaireName}}</span>
        </div>
        <div class="toolbar-section right" style="width: 33%;text-align: right">
            <!-- 右邊內容，例如選單或儲存按鈕 -->
            <button class="header-right-btn-language btn-text btn-size-l" (click)="leavePage()">
                離開
            </button>
        </div>
    </mat-toolbar>
    <mat-progress-bar mode="determinate" [value]="percentValue"></mat-progress-bar>
    <div style="background-color: #f2f7f6;">
        <app-form-detail [questions]="currentGroupIndex === 0 ? [] : groupedQuestions[currentGroupIndex - 1]"
            [answerGroups]="currentAnswerGroups" [groupIndex]="currentGroupIndex"
            [groupCount]="groupedQuestions.length + 1" [groupedQuestions]="groupedQuestions"
            [questionnaireTypeId]="questionnaireTypeId" [questionErrorMessages]="questionErrorMessages"
            [questionPlaceholders]="questionPlaceholders" [totalQuestions]="totalQuestions"
            (navigationChange)="onNavigationChange($event)">
        </app-form-detail>
    </div>
</div>
}
@if(questionnaireTypeId==='3'){
<div class="agreenment-card">
    <mat-toolbar class="custom-toolbar">
        <div class="toolbar-section left" style="width: 33%;">
            <!-- 左邊內容，例如返回按鈕 -->

        </div>
        <div class="toolbar-section center" style="width: 33%;text-align: center;">
            <span>健康調查表</span>
        </div>
        <div class="toolbar-section right" style="width: 33%;text-align: right">
            <!-- 右邊內容，例如選單或儲存按鈕 -->

            <button class="header-right-btn-language btn-text btn-size-l" (click)="leavePage()">
                {{ showFormDetail ? '返回列表' : '離開' }}
            </button>
        </div>
    </mat-toolbar>
</div>
@if (!showFormDetail) {
<div class="form-introduction" style="padding:20px;margin:10px auto;line-height: 2;">
    <h1 style="font-size: 28px;letter-spacing: 1px">健檢前的準備問卷</h1>
    <h3 style="color:gray ;font-weight: 300;letter-spacing: 3px;">提前填好，當天報到更順暢</h3>

</div>

@for(data of groupedQuestions; let j = $index; let isLast = $last; track j) {

@if (!isLast || (isLast && myReservation.dataType === '2')) {
<div class="agreenment-card form-introduction" style="border-radius: 17px; padding: 20px; margin: 10px auto;"
    (click)="selectGroup(j)">
    <div class="agreenment-card-content">
        <div class="flex-row-flex-start  title-indent">
            <app-text size="m" weight="m" color="gray-900">{{mapHealthCheckIndexToContainerName(j).title}}</app-text>
        </div>
        <div class="flex-row-flex-start">
            <!-- <app-tag size="md" [color]="groupCompletionStatus[j] ? 'filled-dark-green' : 'filled-gray'">
                </app-tag> -->
            @if(groupCompletionStatus[j]){
            <img src="/assets/img/member-complete-state.svg" alt="alert">
            }
            <app-text size="m" weight="m" [color]="groupCompletionStatus[j] ? 'gray-700' : 'primary-700'">
                {{ groupCompletionStatus[j] ? '已完成' : '開始填寫' }}
            </app-text>
            <img [src]="groupCompletionStatus[j] ? '/assets/img/Arrow_line_right.png' : '/assets/img/Arrow_line_right_green.png'"  width="18" height="18" alt="alert">

        </div>
    </div>
    <hr>
    <div class="agreenment-card-content" style="margin-bottom: 4px;">
        <div class="flex-row-flex-start agreenment-detail">
            <app-text size="m" weight="s" color="gray-500">
                {{ mapHealthCheckIndexToContainerName(j).detail }}
            </app-text>
        </div>
    </div>
    <div class="agreenment-card-content">
        <div class="flex-row-flex-start agreenment-detail">
            <app-text size="m" weight="s" color="gray-500">
                共 {{ mapHealthCheckIndexToContainerName(j).totalPage }} 頁
            </app-text>
        </div>
    </div>
</div>

}
}
<div class="page-btn-block" style="position: initial; background-color: initial;">
    <button mat-button class="btn-fill-primary btn-size-l" style="border: initial;" (click)="leavePage()">
        送出問卷
    </button>
</div>
}

@if (showFormDetail) {
<app-form-detail [questions]="healthGroupedMap[currentGroupIndex][currentSubGroupIndex]"
    [answerGroups]="currentAnswerGroups" [questionnaireTypeId]="questionnaireTypeId" [cardIndex]="currentGroupIndex"
    [groupIndex]="currentSubGroupIndex" [groupCount]="healthGroupedMap[currentGroupIndex]?.length || 0"
    [groupedQuestions]="groupedHealthQuestions" [totalQuestions]="totalQuestions"
    [questionErrorMessages]="questionErrorMessages" [questionPlaceholders]="questionPlaceholders"
    (navigationChange)="onNavigationChange($event,currentGroupIndex)">
</app-form-detail>
}

}
@if(questionnaireTypeId!=='1'&&questionnaireTypeId!=='2'&&questionnaireTypeId!=='3'){
<div class="agreenment-card">
    <mat-toolbar class="custom-toolbar">
        <div class="toolbar-section left" style="width: 33%;">
            <!-- 左邊內容，例如返回按鈕 -->

        </div>
        <div class="toolbar-section center" style="width: 33%;text-align: center;">
            <span>{{questionnaireName}}</span>
        </div>
        <div class="toolbar-section right" style="width: 33%;text-align: right">
            <!-- 右邊內容，例如選單或儲存按鈕 -->
            <button class="header-right-btn-language btn-text btn-size-l" (click)="leavePage()">
                離開
            </button>
        </div>
    </mat-toolbar>
    <mat-progress-bar mode="determinate" [value]="percentValue"></mat-progress-bar>
    <div style="background-color: #f2f7f6;">

        <app-form-detail [questions]="groupedQuestions[currentGroupIndex] || []" [answerGroups]="currentAnswerGroups"
            [groupIndex]="currentGroupIndex" [groupCount]="groupedQuestions.length"
            [groupedQuestions]="groupedQuestions" [totalQuestions]="totalQuestions"
            (navigationChange)="onNavigationChange($event)">
        </app-form-detail>


    </div>

</div>
}